import { render, staticRenderFns } from "./CommentInput.vue?vue&type=template&id=22fdbd43&scoped=true"
import script from "./CommentInput.vue?vue&type=script&lang=js"
export * from "./CommentInput.vue?vue&type=script&lang=js"
import style0 from "./styles/comment-input.css?vue&type=style&index=0&id=22fdbd43&prod&scoped=true&lang=css&external"
import style1 from "./styles/comment-shared.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fdbd43",
  null
  
)

export default component.exports